import { not_implemented_type } from '@shared/asserts/utils_asserts';
import { ENUM__field_kind } from '../../_enums/ENUM__field_kind';
import { DTO_GRAPH__edge } from '../../_graph/DTO_GRAPH__edge';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { FIELD__base } from './FIELD__base';

declare module './FIELD__base' {
  interface FIELD__base {
    /*
     * ADDED
     */
    edge__on_added(graph: DTO_GRAPH__instance, edge: DTO_GRAPH__edge): void;

    /*
     * REMOVED
     */

    /*
     * INVISIBLE
     */
  }
}

export function INIT_EXTENSION_FIELD_BASE__edges() {}

/*
 * ADDED
 */

FIELD__base.prototype.edge__on_added = function (graph: DTO_GRAPH__instance, edge: DTO_GRAPH__edge) {
  switch (this.meta.field_kind) {
    case ENUM__field_kind.INPUT:
      break;
    case ENUM__field_kind.OUTPUT:
      break;
    default:
      not_implemented_type(this.meta.field_kind);
  }
};

/*
 * REMOVED
 */
